import React, {useState} from "react";
import EditProfile from "./EditProfile.tsx";
import Password from "./Password.tsx";
import Notifications from "./Notifications.tsx";
import Team from "./Team.tsx";
import Sessions from "./Sassions.tsx";
import Appearance from "./Appearance.tsx";
import DeleteAccount from "./DeleteAccount.tsx";
import {GenericMenuItem} from "../../models/interfaces/genericMenuItem.ts";
import ModalSideMenu from "../ModalSideMenu.tsx";


type SettingsProps = {
  items: GenericMenuItem[];
  activeItemIdx?: number;
};

const Preferences: React.FC<SettingsProps> = ({items, activeItemIdx}: SettingsProps) => {
  const [activeItem, setActiveItem] = useState<GenericMenuItem>(items[activeItemIdx || 0]);

  return (
    <div className="p-12 lg:px-8 md:pt-16 md:px-5 md:pb-8">
      <div className="flex md:block">
        <div className="shrink-0 w-[13.25rem]">
          <ModalSideMenu
            items={items}
            activeItem={activeItem}
            setActiveItem={setActiveItem}
          />
        </div>
        <div className="grow pl-12 md:pl-0">
          {activeItem.id === "edit-profile" && <EditProfile/>}
          {activeItem.id === "password" && <Password/>}
          {activeItem.id === "notifications" && <Notifications/>}
          {activeItem.id === "team" && <Team/>}
          {activeItem.id === "sessions" && <Sessions/>}
          {/*{activeItem.id === "applications" && <Applications/>}*/}
          {activeItem.id === "appearance" && <Appearance/>}
          {activeItem.id === "delete-account" && <DeleteAccount/>}
        </div>
      </div>
    </div>
  );
}

export default Preferences;